import { TrendingUp } from 'lucide-react';
import { Button } from './ui/button';
import { heroData } from '../mock';

export const SiteHeader = () => (
  <header className="fixed inset-x-0 top-0 z-50 border-b border-gray-200 bg-white/80 backdrop-blur-md">
    <div className="container mx-auto px-6 py-4">
      <div className="flex items-center justify-between gap-4">
        <a data-testid="header-home-link" href="/" className="flex shrink-0 items-center gap-2 text-gray-900">
          <TrendingUp aria-hidden="true" className="h-8 w-8 text-[#7c4a97]" />
          <span className="text-2xl font-bold">GenMoney</span>
        </a>
        <nav aria-label="Main navigation" className="hidden items-center gap-5 lg:flex lg:gap-8">
          {[['solutions', 'Solutions'], ['features', 'Features'], ['pricing', 'Pricing'], ['testimonials', 'Testimonials']].map(([id, label]) => (
            <a key={id} data-testid={`header-${id}-link`} href={`/#${id}`} className="font-medium text-gray-700 transition-colors hover:text-[#7c4a97]">{label}</a>
          ))}
          <Button asChild className="bg-[#f49e38] text-white hover:bg-[#e08a28]">
            <a data-testid="header-book-call-link" href={heroData.calendlyLink} target="_blank" rel="noopener noreferrer">Book a free session</a>
          </Button>
        </nav>
        <a data-testid="mobile-pricing-link" href="/#pricing" className="text-sm font-semibold text-[#7c4a97] lg:hidden">Pricing</a>
      </div>
    </div>
  </header>
);